/**
 * @file
 * Attaches the behaviors for the tab components.
 */

(function ($, Drupal) {
  'use strict';

  Drupal.behaviors.testimonials = {
    attach: function attach(context) {
      $(context)
        .find('.testimonials__slider.is-slider')
        .each(function () {
          const $slider = $(this);
          const $dots = $('.testimonials__dots');

          $slider.slick({
            arrows: false,
            dots: true,
            adaptiveHeight: true,
            appendDots: $dots
          });
        });
    }
  };
})(jQuery, Drupal);
